<h1 mat-dialog-title>{{data.dialogTitle}}</h1>
<div mat-dialog-content> 
  <h3>Vuoi davvero eliminare<b> {{data.titolo | uppercase}} </b>?</h3>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onUndoClick()" cdkFocusInitial>Annulla</button>
  <button mat-button [mat-dialog-close]="data" color="warn">Elimina</button>
</div>